<template>
  <div class="hello">
    <el-container
      style=" border: 1px solid #eee"
      :style="{ height: screenHeight - 22 + 'px' }"
    >
      <!-- 侧栏 -->
      <el-aside width="250px" class="slider">
        <div class="logo-flex">
          <div class="logo">
            <h1>誉 医 世 家</h1>
          </div>
        </div>
        <!-- 侧栏导航 -->
        <el-menu
          unique-opened
          :router="true"
          class="el-menu-vertical-demo"
          :default-active="onRoutes"
          background-color="#2f323e"
          text-color="#fff"
          active-text-color="#409EFF"
        >
          <template v-for="item in items">
            <template v-if="item.subs">
              <el-submenu :index="item.index" :key="item.index">
                <template slot="title">
                  <i :class="item.icon"></i>
                  {{ item.title }}
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    v-for="(subItem, i) in item.subs"
                    :key="i"
                    :index="subItem.index"
                    >{{ subItem.title }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :index="item.index" :key="item.index">
                <i :class="item.icon"></i>
                {{ item.title }}
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-aside>
      <!-- 右边显示内容 -->
      <div class="views-container">
        <el-header class="header">
          <div style="flex:1;">
            <!-- 面包屑 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item
                v-for="(item, index) in breadcrumb"
                :key="index"
                >{{ item }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <!-- 用户头像 -->
          <el-dropdown @command="handleCommand">
            <span>
              <div class="header-item">
                <span>{{ greet }} {{ userinfo.account }}</span>
                <img
                  width="50"
                  height="50"
                  style="border-radius:50%;"
                  src="../assets/image/header.gif"
                  alt="img"
                />
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">退出登录</el-dropdown-item>
              <el-dropdown-item command="2">修改密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>
        <!-- 头部动态导航栏 -->
        <el-tabs
          v-model="editableTabsValue"
          type="card"
          closable
          @tab-click="tabClick"
          @tab-remove="tabRemove"
          class="header-tabs"
        >
          <el-tab-pane
            :key="item.name"
            v-for="item in editableTabs"
            :label="item.title"
            :name="item.name"
          ></el-tab-pane>
        </el-tabs>
        <!-- 内容展示区域 -->
        <div
          class="content"
          v-loading="fullscreenLoading"
          style="min-width:1024px;"
          :style="{ height: screenHeight - 162 + 'px' }"
        >
          <!-- <router-view style="min-width:1100px;" :style="{minHeight:(screenHeight-162)+'px'}" /> -->
          <router-view />
        </div>
      </div>
    </el-container>

    <!-- 设置管理员密码 -->
    <el-dialog title="设置管理员密码" :visible.sync="dialogVisiblePassword">
      <el-form
        :model="setPasswordForm"
        :rules="setAdminPasswordRules"
        label-width="120px"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="管理员密码" prop="password">
          <el-input
            v-model.trim="setPasswordForm.password"
            type="password"
            placeholder="请输入管理员密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblePassword = false">取 消</el-button>
        <el-button type="primary" @click="confirmSetPassword('ruleForm')"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import routes from "@/router/index";
import { logout } from "@/api/login";
import { changePwd } from "@/api/admin";
export default {
  name: "Container",
  data() {
    return {
      editableTabsValue: "",
      editableTabs: [],
      breadcrumb: ["首页"], //  面包屑
      screenHeight: 600, //  屏幕高度
      items: [],
      headerList: [{ icon: "el-icon-star-on", title: "退出" }],
      curRouter: "", //  当前的路由名称
      setAdminPasswordRules: {
        password: [
          { required: true, message: "请输入管理员密码", trigger: "blur" },
          { min: 6, max: 20, message: "密码字数在6~20位数", trigger: "blur" },
        ],
      },
      setPasswordForm: {
        password: "",
      },
      dialogVisiblePassword: false,
    };
  },
  mounted() {
    //  监听可视区域高度
    this.screenHeight = document.documentElement.clientHeight;
    window.onresize = () => {
      this.screenHeight = document.documentElement.clientHeight;
    };
    //  获取路由
    let tempRouter = routes.options.routes[3].children;
    let is_super = this.$store.getters.userinfo.is_super;
    if (is_super != 1) {
      tempRouter = tempRouter.filter((e) => e.title != "管理员");
    }
    this.showRouter(tempRouter);
  },
  computed: {
    /**
     * 路由切换
     */
    onRoutes() {
      let index = this.$route.path.replace("/", "");
      this.addTab(index);
      this.curRouter = index;
      return index;
    },
    /**
     * loading加载
     */
    fullscreenLoading() {
      return this.$store.getters.fullscreenLoading;
    },
    /**
     * 用户信息
     */
    userinfo() {
      return this.$store.getters.userinfo;
    },
    /**
     * 问候语
     */
    greet() {
      let hour = new Date().getHours();
      if (hour < 6) {
        return "凌晨好，";
      } else if (hour < 9) {
        return "早上好，";
      } else if (hour < 12) {
        return "上午好，";
      } else if (hour < 14) {
        return "中午好，";
      } else if (hour < 17) {
        return "下午好，";
      } else if (hour < 19) {
        return "傍晚好，";
      } else if (hour < 22) {
        return "晚上好，";
      } else {
        return "夜里好，";
      }
    },
  },
  watch: {
    /**
     * 监听可视区域高度
     */
    screenHeight() {
      this.changePageHeight(this.screenHeight);
    },
  },
  methods: {
    /**
     * 显示路由
     */
    showRouter(tempRouter) {
      this.items = [];
      let tempS = false;
      let tempI = 0;
      tempRouter.forEach((item, index) => {
        //  首先排除type为not的
        if (item.type != "not") {
          tempS ? "" : (tempI = index); //  不存在则记录
          if (item.subIndex || item.subTitle || item.subIcon) {
            tempS = false;
            this.items.forEach((sItem, sIndex) => {
              if (sItem.index == item.subIndex) {
                tempS = true;
                tempI = sIndex;
              }
            });
            //  如果已经存在
            if (tempS) {
              this.items[tempI].subs.push({
                index: item.path.substr(1),
                title: item.title,
              });
            } else {
              this.items.push({
                icon: item.subIcon,
                index: item.subIndex,
                title: item.subTitle,
                subs: [
                  {
                    icon: item.icon,
                    index: item.path.substr(1),
                    title: item.title,
                  },
                ],
              });
            }
          } else {
            this.items.push({
              icon: item.icon,
              index: item.path.substr(1),
              title: item.title,
            });
          }
        }
      });
      this.items = this.items.filter((e) => e.index !== "");
    },
    /**
     * 改变屏幕高度
     */
    changePageHeight(h) {
      this.screenHeight = h;
    },
    /**
     * 点击头部tab
     */
    tabClick(tab) {
      //  如果点击的路由和当前的路由一致则不需要跳转
      if (tab.name == this.curRouter) return;
      // this.$store.dispatch("fullscreenLoading", true);
      this.changeBreadcrumb(tab.name);
      this.editableTabsValue = tab.name;
      this.$router.replace(tab.name);
    },
    /**
     * 添加头部路由
     */
    addTab(targetName) {
      //  判断没有找到tab导航则添加
      if (!this.editableTabs.find((tab) => tab.name === targetName)) {
        this.editableTabs.push({
          title: this.routerName(targetName),
          name: targetName,
        });
        // this.$store.dispatch("fullscreenLoading", true);
      }
      this.changeBreadcrumb(targetName);
      this.editableTabsValue = targetName;
    },
    /**
     * 移除头部tab
     */
    tabRemove(targetName) {
      // this.$store.dispatch("fullscreenLoading", true);
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              //  选中上一个tab
              activeName = nextTab.name;
            }
          }
        });
      }
      /**
       * 回到上一个tab
       */
      this.changeBreadcrumb(activeName);
      this.editableTabsValue = activeName;
      this.editableTabs = this.editableTabs.filter(
        (tab) => tab.name !== targetName
      );
      this.$router.replace(activeName);
    },
    /**
     * 路由名称过滤
     */
    routerName(i) {
      return routes.options.routes[3].children.find(
        (e) => e.path.substr(1) == i
      ).title;
    },
    /**
     * 面包屑导航
     */
    changeBreadcrumb(i) {
      this.breadcrumb = [];
      this.items.map((item) => {
        if (item.subs) {
          //  path包含
          item.subs.forEach((e) => {
            if (e.index == i) {
              this.breadcrumb.push(item.title);
              this.breadcrumb.push(e.title);
            }
          });
        } else {
          item.index == i ? this.breadcrumb.push(item.title) : null;
        }
      });
    },
    /**
     * 退出登录
     */
    handleCommand(i) {
      if (parseInt(i) == 1) {
        this.$confirm("是否要退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            logout().then(() => {
              localStorage.removeItem("localStorage");
              this.$router.replace("login");
            });
          })
          .catch(() => {});
      } else {
        this.dialogVisiblePassword = true;
      }
    },
    /**
     * 修改管理员密码
     */
    confirmSetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("fullscreenLoading", true);
          changePwd({
            id: this.$store.getters.userinfo.id,
            password: this.setPasswordForm.password,
          }).then((res) => {
            if (res.data == true) {
              this.$message.success("设置成功!");
              this.dialogVisiblePassword = false;
              this.$store.dispatch("fullscreenLoading", false);
            } else {
              this.$message.error(res.data);
            }
          });
        } else {
          this.$message.error("输入内容有误");
          return false;
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../assets/css/container.css"></style>
<style scoped></style>
